export const pixels = {
  namespaced: true,
  state: () => ({
    fbPixels: [],
    gaPixels: []
  }),
  mutations: {
    setFbPixel(state, pixel) {
      state.fbPixels.push(pixel)
    },
    setGaPixel(state, pixel) {
      state.fbPixels.push(pixel)
    }
  },
  actions: {
    setFbPixel({ commit }, pixel) {
      commit('setFbPixel', pixel)
    },
    setGaPixel({ commit }, pixel) {
      commit('setGaPixel', pixel)
    }
  }
}
